// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bfv_a","AdSlotBranding__desktop":"bfv_b","AdSlotBranding__mobile":"bfv_c"};